import { useDependencies } from '@/scopes/common/infrastructure/dependencies';
import { useAccommodationContext } from '@/react-pages/Prices/AccommodationContext';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export function useAccommodationAvailability() {
  const { availabilityApiClient } = useDependencies();
  const { contextItemId, accoId, bookingGateId } = useAccommodationContext();

  const { data, isFetching } = useQuery({
    queryKey: ['availability', accoId],
    queryFn: async () => {
      return availabilityApiClient.isAccommodationAvailable({ contextItemId, accoId, bookingGateId });
    },
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });

  return {
    isAccommodationAvailable: data?.isAccommodationAvailable ?? false,
    isFlightOnly: data?.isFlightOnly ?? false,
    transportTypes: data?.transportTypes ?? [],
    isFetching,
  };
}
